/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Authorize.tsx
 *
 * Project Title : RDR7000
 *
 * Description   : Authorize component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : July 31, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : July 31, 2020
 * Description   : Added authorize component to show the landing page with loader
 *
 *
 ******************************************************************************/

import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Search } from 'history';
import { Loader } from '@scuf/common';
import { useAuth } from './AuthProvider';

export const Authorize: FC = () => {
  const location = useLocation<{ search: Search }>();
  const { login } = useAuth();

  useEffect(() => {
    login!(location);

    // eslint-disable-next-line
    // tslint:disable-next-line: align
  }, []);

  return (
    <div>
      <Loader text="Login into RDR7K Portal..." overlayColor="#a0a0a0">
        <div className="placeholder" />
      </Loader>
    </div>
  );
};
